import React from 'react'

class FileDirItem extends React.Component {
    constructor(props){
        super(props);
    }

    handleClickDir = (index) => {
        this.props.handleClickDir(this.props.depth);
    };

    render(){
        let color;
        if (this.props.isLast && this.props.depth !== 0) {
            color = '#010000';
        } else {
            color = '#688DF5';
        }
        return(
            <a onClick={this.handleClickDir} href='javascript:;'><h6 style={{display:'inline',color:color,fontSize:12 + 'px'}}>{this.props.item}</h6></a>
        );
    }
}

export default FileDirItem